import { createReducer } from "@reduxjs/toolkit";
import { MAXIMO_TIME_ZONE } from "src/config/сonstants";
import { DBClientUser, DBVendorUser, ID } from "../../types";
import { isDispatch, isManager, isTechnician } from "../../utils";
import { logInUser, logOutUser, updateLastActivity, extendSession } from "../actions/user";

export type UserState = DBClientUser &
  DBVendorUser & {
    loggedIn: boolean;
    id: ID;
    loginDate: null | string;
    lastActivity: null | string;
    profilePicture?: string;
    maximoTimezone: string;
    isManager: boolean;
    isDispatch: boolean;
    role: "manager" | "dispatch" | "technician" | "";
  };

export const initialState: UserState = {
  loginDate: null,
  lastActivity: null,
  loggedIn: false,
  id: "",
  clientId: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  maximoTimezone: MAXIMO_TIME_ZONE,
  isManager: false,
  vendorId: "",
  isDispatch: false,
  role: "",
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(logInUser, (state, action) => {
      // Dispatch users should have the same unrestricted access level as managers.
      const hasFullAccess = isManager(action.payload) || isDispatch(action.payload);

      return {
        ...state,
        ...action.payload,
        isManager: hasFullAccess,
        loggedIn: !!action.payload.id,
        loginDate: new Date().toISOString(),
        lastActivity: new Date().toISOString(),
        isDispatch: isDispatch(action.payload),
        role: isManager(action.payload)
          ? "manager"
          : isDispatch(action.payload)
            ? "dispatch"
            : isTechnician(action.payload)
              ? "technician"
              : "",
      };
    })
    .addCase(logOutUser, () => ({
      ...initialState,
    }))
    .addCase(updateLastActivity, (state) => ({
      ...state,
      lastActivity: new Date().toISOString(),
    }))
    .addCase(extendSession, (state) => ({
      ...state,
      loginDate: new Date().toISOString(),
      lastActivity: new Date().toISOString(),
    }));
});
